import React from 'react';

export const ConfirmContent = ({
  title,
  onConfirm,
  onDismiss,
}) => (
  <div>
    <h4>
      {title}
    </h4>

    <button onClick={onDismiss}>No</button>
    <button onClick={onConfirm}>
      Yes
    </button>
  </div>
);
